exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vault-operations-search-section {\n  display: flex;\n  justify-content: center; }\n\n.vault-operations-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 5px !important; }\n\n.vault-operations-badge-section {\n  border-radius: 4px !important;\n  background-color: #5cb85c !important;\n  font-size: 13px !important; }\n\n.col-w-13 {\n  width: 13%; }\n\n.col-w-09 {\n  width: 9%; }\n\n.col-w-10 {\n  width: 10%; }\n\n.margin-bottom-40 {\n  margin-bottom: 40px; }\n\n.vault-date-col-width {\n  width: 7%; }\n\n.vault-operation-date-picker-w-23 {\n  width: 23%; }\n\n.vault-operation-branch-dd .multiSelect .checkboxLayer {\n  max-height: 350px !important;\n  overflow-y: auto !important; }\n\n.vault-operation-branch-dd .multiSelect .show {\n  display: block !important; }\n\n.undo-delivery-icon .btn-xs {\n  padding: 0px 1px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/vault_operations/vault_operations.scss
// module id = 1193
// module chunks = 1